import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08cdb4dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h4 title fw-normal text-primary mb-16" }
const _hoisted_2 = { class: "middle-container" }
const _hoisted_3 = { class: "middle-content mb-16" }
const _hoisted_4 = { class: "row row-cols-3 mb-16" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "section-title fw-bold" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "section-title fw-bold" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "section-title fw-bold" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "row row-cols-3 mb-24" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "section-title fw-bold" }
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "section-title fw-bold" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "section-title fw-bold" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "section-title fw-bold d-flex justify-content-between align-items-center mb-12" }
const _hoisted_27 = { class: "authorizations" }
const _hoisted_28 = { class: "d-inline product" }
const _hoisted_29 = { class: "d-inline product" }
const _hoisted_30 = { class: "d-inline product" }
const _hoisted_31 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-view-light fw-bold icon-xs" }, null, -1))
const _hoisted_33 = {
  key: 1,
  class: "item d-flex align-items-center justify-content-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_patient_purchase_authorization_show = _resolveComponent("the-patient-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('Visualización de consulta')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Inicio')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$str.formatDateTime(_ctx.currentConsultation.initDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Fin')), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(!!_ctx.currentConsultation.endDate ? _ctx.$str.formatDateTime(_ctx.currentConsultation.endDate) : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('Tipo de consulta')), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.type()), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('Medio')), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.via()), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('Lugar')), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(!!_ctx.currentConsultation.clinic ? _ctx.currentConsultation.clinic.name : _ctx.$t('- Sin clínica asociada -')), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('Tratamiento')), 1),
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.currentConsultation.treatment && _ctx.currentConsultation.treatment.treatmentProtocolPhases ? '[' +
                _ctx.$str.formatDate(_ctx.currentConsultation.treatment.treatmentProtocolPhases[0].initDate) + '] ' +
                _ctx.currentConsultation.treatment.treatmentProtocolPhases[0].protocolPhase.protocol.name +
                ' (' + _ctx.currentConsultation.treatment.treatmentProtocolPhases[0].protocolPhase.name + ')' :
                _ctx.$t('- Sin tratamiento asociado -')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('Autorizaciones relacionadas')), 1),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.consultationAuthorizations().length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.consultationAuthorizations(), (purchaseAuthorization, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item d-flex align-items-center justify-content-between",
                      key: index
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.dueDate)), 1),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('Estado: {status}', { status: _ctx.status(purchaseAuthorization.status) })), 1),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('{count} productos distintos', { count: purchaseAuthorization.products.length })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_v_button, {
                          variant: "icon",
                          class: "p-0 me-16",
                          onClick: ($event: any) => {_ctx.setCurrentPurchase(purchaseAuthorization); _ctx.modalToShow = 'the-purchase-authorization-show'}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t('No hay autorizaciones relacionadas con esta consulta')), 1))
            ])
          ])
        ])
      ])
    ]),
    (_ctx.modalToShow === 'the-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_patient_purchase_authorization_show, {
          key: 0,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => {_ctx.modalToShow = null; _ctx.setCurrentPurchase()})
        }))
      : _createCommentVNode("", true)
  ], 64))
}